import React, { useState, useRef, useEffect } from "react";
import { Dialog, DialogContent, DialogActions, DialogTitle, TextField, InputAdornment, Button, IconButton, Alert, AlertTitle, Box, FormHelperText, Paper, FormControl, Select, InputLabel, MenuItem, Grid } from "@mui/material";
import Draggable from 'react-draggable';
import { useTranslation } from 'react-i18next'
import CloseIcon from '@mui/icons-material/Close';
/* REQUEST */
import { createReport } from "utils/Reports";
import { getCategories } from "utils/Category";

const PaperComponent = (props) => {
    const nodeRef = useRef(null);
    return (
        <Draggable
            nodeRef={nodeRef}
            handle="#draggable-dialog-title"
            cancel={'[class*="MuiDialogContent-root"]'}
        >
            <Paper {...props} ref={nodeRef} />
        </Draggable>
    );
}

const AddReports = ({ open, setOpen, rows, setAlert, setOpenAlert, reloading }) => {
    const { t } = useTranslation()
    const [name, setName] = useState('')
    const [nameLength, setNameLength] = useState(0)
    const [status, setStatus] = useState('')
    const [for_employee, setForEmployee] = useState('')
    const [description, setDescription] = useState('')
    const [descriptionLength, setDescriptionLength] = useState(0)
    const [slug, setSlug] = useState('')
    const [slugLength, setSlugLength] = useState(0)
    const [category, setCategory] = useState('')
    const [categorySelected, setCategorySelected] = useState('')
    const [alerts, setAlerts] = useState(false)
    const [loading, setLoading] = useState(false)

    useEffect(() => {
        if(!open) return;

        const getCategory = async () => {
            try{
                setLoading(true)
                const response = await getCategories()
                if (response.length > 0) {
                    setCategory(response)
                }

            } catch (error) {
                console.log('Error:', error)
                setLoading(false)
            } finally {
                setLoading(false)
            }
        }

        getCategory()
    }, [open])

    const existName = (name) => {
        let exist = false
        rows.forEach((row) => {
            if (String(row.name).toLocaleLowerCase() === String(name).toLocaleLowerCase()) {
                exist = true
            }
        })
        return exist
    }

    const closeForm = () => {
        setOpen(false)
        setName('')
        setStatus('')
        setForEmployee('')
        setDescription('')
        setSlug('')
        setCategory('')
        setCategorySelected('')
    }

    const changes = () => {
        const hasChanges = name !== '' || description !== '' || status !== '' || for_employee !== '' || categorySelected !== '' || slug !== ''
        return hasChanges ? setAlerts(true) : closeForm()
    }

    const addReport = async () => {
        setLoading(true)
        const response = await createReport({
                "name": name,
                "status": status,
                "for_employees": for_employee,
                "description": description,
                "slug": slug,
                "category_id": categorySelected
            })
        //console.log('response:', response)
        if (response > 0) {
            setAlert({
                msg: t('custom_reports.reports.table.dialog.add.messages.success'),
                severity: 'success'
            })
            setOpenAlert(true)
            setLoading(false)
            closeForm()
            reloading()
        } else {
            setAlert({
                msg: t('custom_reports.reports.table.dialog.add.messages.error'),
                severity: 'error'
            })
            setOpenAlert(true)
            setLoading(false)
        }

        //console.log(report)
    }

    const disabled = () => {
        return name === '' || description === '' || status === '' || for_employee === '' || categorySelected === '' || slug === ''
    }


    return (
        <Dialog
            maxWidth="xs"
            fullWidth
            open={open}
            PaperComponent={PaperComponent}
            onClose={(event, reason) => {
                if (reason !== 'backdropClick') {
                    return;
                }
                changes()
            }}
            aria-labelledby="draggable-dialog-title"
            aria-describedby="draggable-dialog-title-description"
        >
            <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">{t('custom_reports.reports.table.dialog.add.title')}</DialogTitle>
            <IconButton
                aria-label="close"
                onClick={() => changes()}
                sx={{
                    position: 'absolute',
                    right: 8,
                    top: 8,
                    color: (theme) => theme.palette.grey[500],
                }}
            >
                <CloseIcon />
            </IconButton>
            <Box sx={{ top: 0, zIndex: 10, pb: 1 }}>
                {
                    alerts &&
                    <Alert
                        variant='filled'
                        severity="warning"
                        sx={{ mt: 2 }}
                        action={
                            <>
                                <Button onClick={() => closeForm()} color="inherit" size="small" variant='text' disableElevation>
                                    {t('custom_reports.reports.table.dialog.add.alert.unsaved_changes.buttons.yes')}
                                </Button>
                                <Button onClick={() => setAlerts(false)} color='inherit' size='small' variant='text' disableElevation>
                                    {t('custom_reports.reports.table.dialog.add.alert.unsaved_changes.buttons.no')}
                                </Button>
                            </>
                        }
                    >
                        <AlertTitle>{t('custom_reports.reports.table.dialog.add.alert.unsaved_changes.message')}</AlertTitle>
                    </Alert>
                }
            </Box>
            <DialogContent dividers>
                <Grid container>
                    <Grid size={{ xs: 10, sm: 12, md: 12, lg: 12 }}>
                        <TextField
                            id={'input-name'}
                            fullWidth
                            label={t('custom_reports.reports.table.dialog.add.name')}
                            value={name}
                            autoComplete="off"
                            onChange={(e) => {
                                setName(e.target.value)
                                setNameLength(e.target.value.length)
                                existName(e.target.value)
                            }}
                            placeholder={t('custom_reports.reports.table.dialog.add.max_name')}
                            required
                            error={existName(name)}
                            slotProps={{
                                htmlInput: { maxLength: 100 },
                                input: {
                                    endAdornment: <InputAdornment position="end">{`${nameLength}/100`}</InputAdornment>,
                                },
                            }}
                        />
                        <FormHelperText
                            sx={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                mt: 0.5,
                                px: 1.75
                            }}
                        >
                            <span>{existName(name) ? t('custom_reports.reports.table.dialog.add.exist_name') : ''}</span>
                            {/* <span></span> */}
                        </FormHelperText>
                    </Grid>
                    <Grid size={{ xs: 10, sm: 12, md: 12, lg: 12 }} sx={{ mt: 1.5 }}>
                        <FormControl fullWidth>
                            <InputLabel id="select-label-status">{t('custom_reports.reports.table.dialog.add.status')}</InputLabel>
                            <Select
                                labelId="select-label-status"
                                id="select-label-status"
                                value={status}
                                label={t('custom_reports.reports.table.dialog.add.status')}
                                onChange={(e) => setStatus(e.target.value)}
                            >
                                <MenuItem value={"Enabled"}>{t('custom_reports.reports.table.dialog.add.select_status.enabled')}</MenuItem>
                                <MenuItem value={"Disabled"}>{t('custom_reports.reports.table.dialog.add.select_status.disabled')}</MenuItem>
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid size={{ xs: 10, sm: 12, md: 12, lg: 12 }} sx={{ mt: 1.5 }}>
                        <FormControl fullWidth>
                            <InputLabel id="select-label-foremployee">{t('custom_reports.reports.table.dialog.add.for_employee')}</InputLabel>
                            <Select
                                labelId="select-label-foremployee"
                                id="select-label-foremployee"
                                value={for_employee}
                                label={t('custom_reports.reports.table.dialog.add.for_employee')}
                                onChange={(e) => setForEmployee(e.target.value)}
                            >
                                <MenuItem value={"Yes"}>{t('custom_reports.reports.table.dialog.add.select_for_employee.yes')}</MenuItem>
                                <MenuItem value={"No"}>{t('custom_reports.reports.table.dialog.add.select_for_employee.no')}</MenuItem>
                            </Select>
                        </FormControl>
                    </Grid>
                </Grid>
                <Grid size={{ xs: 10, sm: 12, md: 12, lg: 12 }} sx={{ mt: 1.5 }}>
                    <TextField
                        id="input-slug"
                        fullWidth
                        label={t('custom_reports.reports.table.dialog.add.slug')}
                        value={slug}
                        autoComplete="off"
                        onChange={(e) => {
                            setSlug(e.target.value)
                            setSlugLength(e.target.value.length)
                        }}
                        placeholder={t('custom_reports.reports.table.dialog.add.max_slug')}
                        required
                        slotProps={{
                            htmlInput: { maxLength: 100 },
                            input: {
                                endAdornment: <InputAdornment position="end">{`${slugLength}/100`}</InputAdornment>,
                            }
                        }}
                    />
                </Grid>
                <Grid size={{ xs: 10, sm: 12, md: 12, lg: 12 }} sx={{ mt: 1.5 }}>
                    <FormControl fullWidth>
                        <InputLabel id="select-label-category">{t('custom_reports.reports.table.dialog.add.category')}</InputLabel>
                        <Select
                            labelId="select-label-category"
                            id="select-label-category"
                            value={categorySelected}
                            label={t('custom_reports.reports.table.dialog.add.category')}
                            onChange={(e) => setCategorySelected(e.target.value)}
                        >

                            {
                                category ? category.map((cat) => (
                                    <MenuItem key={cat.id} value={cat.id}>{cat.name}</MenuItem>
                                )) : <MenuItem value={1}>Category Default</MenuItem>
                            }

                        </Select>
                    </FormControl>
                </Grid>
                <Grid size={{ xs: 10, sm: 12, md: 12, lg: 12 }} sx={{ mt: 1.5 }}>
                    <TextField
                        id="input-description"
                        fullWidth
                        label={t('custom_reports.reports.table.dialog.add.description')}
                        value={description}
                        autoComplete="off"
                        onChange={(e) => {
                            setDescription(e.target.value)
                            setDescriptionLength(e.target.value.length)
                        }}
                        rows={4}
                        multiline
                        placeholder={t('custom_reports.reports.table.dialog.add.max_description')}
                        slotProps={{
                            htmlInput: { maxLength: 255 },
                            input: {
                                endAdornment: <InputAdornment position="end">{`${descriptionLength}/255`}</InputAdornment>,
                            }
                        }}
                    />
                </Grid>
            </DialogContent>
            <DialogActions>
                <Button variant="contained" color="error" onClick={() => changes()}>{t('custom_reports.reports.table.dialog.add.buttons.cancel')}</Button>
                <Button variant="contained" color="primary" loading={loading} onClick={() => addReport()} disabled={disabled()}>{t('custom_reports.reports.table.dialog.add.buttons.add')}</Button>
            </DialogActions>
        </Dialog>
    )
}

export { AddReports };